module.exports = __webpack_public_path__ + "img/has_not_started.1766306608134.png";